import Vue from 'vue'
import axios from 'axios'
export default {
  namespaced: true,
  state: () => ({
    loading: false,
    last_seen: null,
    last_notification: null,
    notifications: {}
  }),
  getters: {
    notifications: (state) => {
      const notifications = Object.values(state.notifications)
      notifications.sort((a, b) => {
        if (a.created_at < b.created_at) {
          return 1
        }
        if (a.created_at > b.created_at) {
          return -1
        }
        return 0
      })
      return notifications
    },
    isRead (state) {
      if (state.last_notification === null) {
        return true
      }
      if (state.last_seen === null) {
        return false
      }
      if (state.last_notification.created_at >= state.last_seen) {
        return false
      }
      return true
    },
    isLoading: state => state.loading
  },
  mutations: {
    setLoading (state, val) {
      state.loading = val
    },
    set (state, notifications) {
      for (const item of notifications) {
        if (!state.notifications[item.id]) {
          Vue.set(state.notifications, item.id, {})
        }
        Vue.set(state.notifications[item.id], 'id', item.id)
        Vue.set(state.notifications[item.id], 'action', item.action)
        Vue.set(state.notifications[item.id], 'created_at', item.created_at)
        Vue.set(state.notifications[item.id], 'entity', item.entity)
        Vue.set(state.notifications[item.id], 'entity_id', item.entity_id)
        Vue.set(state.notifications[item.id], 'entity_type', item.entity_type)
      }
    },
    // pushNotification (state, notification) {
    //   const notifications = state.notifications.slice(0)
    //   notifications.push(notification)
    //   notifications.sort((a, b) => {
    //     if (a.created_at < b.created_at) {
    //       return 1
    //     }
    //     if (a.created_at > b.created_at) {
    //       return -1
    //     }
    //     return 0
    //   })
    //   state.notifications = notifications
    // },
    setNotification (state, { last_seen, last_notification }) {
      if (last_notification) {
        state.last_notification = last_notification
      }
      if (last_seen) {
        state.last_seen = last_seen
      }
    },
    reset (state) {
      Vue.set(state, 'notifications', {})
    }
  },
  actions: {
    async init ({ commit, rootState }) {
      if (!rootState.auth.loggedIn) {
        return
      }
      commit('setLoading', true)
      try {
        const response = await axios.get('/api/notifications/summary')
        commit('setNotification', {
          last_notification: response.data.data.last_notification,
          last_seen: response.data.data.last_seen
        })
        commit('setLoading', false)
      } catch (err) {
        commit('alert/setError', err, { root: true })
        commit('setLoading', false)
      }
    },
    async seen ({ commit }) {
      commit('setLoading', true)
      try {
        const response = await axios.post('/api/notifications/seen')
        commit('setNotification', {
          last_seen: response.data.data.last_seen
        })
        commit('setLoading', false)
      } catch (err) {
        commit('alert/setError', err, { root: true })
        commit('setLoading', false)
      }
    }

  }
}
